import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { ClipboardList } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ListMandatoryProcedures, {
    getCompletedCount,
} from '@/pages/folders/index/_partials/lists/ListMandatoryProcedures';

export default function SheetMandatoryProcedures({
    open,
    onClose,
    mandatoryProcedures = [],
    children = [],
    onNavigate,
    onCreate,
}) {
    const { t } = useTranslation();
    const completedCount = getCompletedCount(mandatoryProcedures, children);

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[500px]! md:max-w-[500px]! flex flex-col p-0">
                <SheetHeader className="px-5 py-4 border-b border-border">
                    <div className="flex items-center gap-2.5">
                        <div className="w-9 h-9 bg-warning/15 rounded-lg flex items-center justify-center shrink-0">
                            <ClipboardList className="h-4 w-4 text-warning" />
                        </div>
                        <div>
                            <SheetTitle className="text-base font-semibold text-foreground">
                                {t('folders:proceduresObligatoires')}
                            </SheetTitle>
                            <p className="text-xs text-muted-foreground">
                                {completedCount}/{mandatoryProcedures.length} {t('folders:finalisee')}
                                {mandatoryProcedures.length > 1 ? 's' : ''}
                            </p>
                        </div>
                    </div>
                </SheetHeader>

                <ListMandatoryProcedures
                    mandatoryProcedures={mandatoryProcedures}
                    children={children}
                    onNavigate={onNavigate}
                    onCreate={onCreate}
                />

                <SheetFooter className="px-5 py-4 border-t border-border">
                    <Button variant="solid" color="dark" className="w-full" onClick={onClose}>
                        {t('folders:fermer')}
                    </Button>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
